import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e633cd12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = { class: "grid grid-cols-2 text-center md:grid-cols-5 px-6 sm:space-x-4 justify-center lg:justify-start py-4 lg:py-0 bg-gray-50 lg:bg-white" }
const _hoisted_3 = {
  class: "mx-auto",
  style: {"text-wrap":"nowrap"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 border-b-2 inset-x-0" }, null, -1))
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  key: 0,
  class: "absolute left-0 inset-y-0 grid place-items-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l h-3" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = {
  key: 1,
  class: "align-middle text-sm ml-2"
}

import { Icon } from '@iconify/vue';
interface TabItem {
  title?: string;
  icon?: string;
  to?: string;
}

interface Props {
  tabs?: TabItem[];
  modelValue?: number;
  type?: 'toggle' | 'line';
}


export default /*#__PURE__*/_defineComponent({
  props: {
    tabs: { default: undefined },
    modelValue: { default: undefined },
    type: { default: 'line' }
  },
  emits: ['update:modelValue'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (__props.type === 'line')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(tab.to ? 'router-link' : 'div'), {
              to: tab.to,
              key: index,
              class: _normalizeClass(["relative inline-flex items-center py-2 space-x-1 z-10 cursor-pointer text-center px-0 md:px-4 justify-self-center", [
          index === __props.modelValue
            ? 'border-primary border-b'
            : 'border-transparent hover:border-gray-500',
          {
            'pr-4': tab.icon,
            'md:col-span-1 col-span-2': index === 0,
          },
        ]]),
              style: { 'border-bottom-width': '3px' },
              onClick: ($event: any) => (_ctx.$emit('update:modelValue', index))
            }, {
              default: _withCtx(() => [
                (tab.icon)
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 0,
                      icon: tab.icon
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_3, _toDisplayString(tab.title), 1)
              ]),
              _: 2
            }, 1032, ["to", "class", "onClick"]))
          }), 128))
        ]),
        _hoisted_4
      ]))
    : (__props.type === 'toggle')
      ? (_openBlock(), _createBlock(_component_BaseBox, {
          key: 1,
          size: "small",
          padding: "p-0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(tab.to ? 'router-link' : 'div'), {
                  key: index,
                  class: _normalizeClass(["tab--hovering p-4 relativ cursor-pointer relative", { 'text-primary': index === __props.modelValue }]),
                  to: tab.to,
                  onClick: ($event: any) => (_ctx.$emit('update:modelValue', index))
                }, {
                  default: _withCtx(() => [
                    (index > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, [
                      (tab.icon)
                        ? (_openBlock(), _createBlock(_unref(Icon), {
                            key: 0,
                            icon: tab.icon,
                            class: "text-2xl"
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      (tab.title)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(tab.title), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "to", "onClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
}
}

})